export enum InstructionsEnum {
    ClientCode = 'client-code',
    DefaultTileLayer = 'default-tile-layer',
    MapIframeCustomId = 'map-iframe-id',
    HideMapTiles = 'hide-map-tiles',
    SendAnimationEnd = 'send-animation-end',
    MapTileLayerAccess = 'tile-layer-access',
    MapAttributes = 'map-attributes',
    BreakpointsButtonActivation = 'break-point-button-activation',
    SlopeServiceActivation = 'activate-slope-service',
    CurrentCenterAndZoom = 'get-current-center-zoom',
    CurrentBoundingBox = 'get-current-bounding-box',
    DecreaseZoomControlAmount = 'decrease-zoom-control-amount',
    SinglePolygon = 'single-polygon-info',
    MultiPolygonsInfo = 'multi-polygons-info',
    MultiPolygonEditedID = 'edited-polygon-id',
    UsePolygonCluster = 'use-polygon-cluster',
    MinPolygonClusterDisplayZoom = 'min-polygon-cluster-zoom',
    EditDrawnPolygons = 'edit-drawn-polygons',
    EditSingleDrawnPolygon = 'edit-single-drawn-polygon',
    DeletedDrawnPolygonID = 'deleted-drawn-polygon-id',
    PolygonDrawActivation = 'draw-polygon-activation',
    DistanceToPolygonInfo = 'distance-to-polygon-info',
    PolylineDrawActivation = 'draw-polyline-activation',
    SingleMarker = 'single-marker',
    EditZoom = 'edit-zoom',
    Markers = 'markers-info',
    RegionMarkers = 'regionMarkers-info',
    Modal = 'modal-body',
    GeneratePoints = 'generate-points',
    MapOptions = 'map-options',
    IsRegionDataLoading = 'isRegionDataLoading',
    IsShowRegionLayers = 'isShowRegionLayers',
    IsShowDetailsButton = 'isShowDetailsButton',
    isOnMapClick = 'isOnMapClick',

    MapDetailsBody = 'mapDetails-body',
    ActionsButtons = 'actions-buttons',
}
